// Shared scaffolding for the mock frontend build. Every net-new feature domain
// (src/api/<domain>/index.ts) ships typed functions whose SIGNATURES are the
// real backend contract and whose bodies are mock stand-ins — go-live = replace
// the body with the `// Real:` apiClient call. Delete this module when the last
// domain goes live.

/** Simulated network latency so loading/skeleton states are exercised in dev. */
export const sleep = (ms = 200) => new Promise<void>((r) => setTimeout(r, ms));

/**
 * Base class for every mock-domain error so a single guard (isMockError) can
 * catch them all, while each domain subclasses it (e.g. `class AccountError
 * extends MockDomainError {}`) to keep precise `instanceof` checks at call sites.
 */
export class MockDomainError extends Error {
  constructor(
    public code: string,
    message?: string
  ) {
    super(message ?? code);
    this.name = new.target.name;
  }
}

export const isMockError = (e: unknown): e is MockDomainError =>
  e instanceof MockDomainError;
